var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.69141C1.5 7.58142 1.76392 8.45145 2.25839 9.19147C2.75285 9.93149 3.45566 10.5083 4.27792 10.8489C5.10019 11.1895 6.00499 11.2786 6.87791 11.1049C7.75082 10.9313 8.55264 10.5027 9.18198 9.87339C9.81132 9.24405 10.2399 8.44223 10.4135 7.56931C10.5872 6.6964 10.4981 5.7916 10.1575 4.96933C9.81686 4.14706 9.24009 3.44426 8.50007 2.94979C7.76004 2.45533 6.89002 2.19141 6 2.19141C4.74198 2.19614 3.53448 2.68702 2.63 3.56141L1.5 4.69141",
    stroke: "#726C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.19141V4.69141H4",
    stroke: "#726C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.19141V6.69141L8 7.69141",
    stroke: "#726C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.aac5b099c31b5da0b69eecc10085e016.svg";
export { ForwardRef as ReactComponent };